module.exports = __webpack_public_path__ + "img/check.bb8ade43.svg";